import React, { useEffect, useState, useRef } from "react";
import Modal from "../Modal/Modal"
import Input from "../input/input";
import RadioButton from "../EditRadioButton/RadioButton"
import SwitchButton from "../SelectionControls/Switch/Switch";
import SimpleDropDown from "../Dropdown/SimpleDropDown/DropDown"
import Tooltip from "../tooltip/tooltip"
import Tabel from "../variantList/variantEditModalTabel/variantEditModalTabel"
import toPersianNumber from "../../helpers/actions/toPersianNumber";
import toEnglishNumber from "../../helpers/actions/toEnglishNumber"
import numberWithCommas from "../../helpers/actions/numberWithCommas";
import style from './proSetting.module.scss';

const ProSetting = (props) => {
    const [modalData, setModalData] = useState({
        tab: 'initialSetting',
        showConfirmButton: false,
        calculateLoading: false,
        showConfirmButton: false,
        error: [],
        margin_type_dropdown: [{ name: 'درصد', value: 'percent' }, { name: 'مبلغ', value: 'price' }, { name: 'قیمت نهایی', value: 'minPrice' }],
        max_margin_type_dropdown: [{ name: 'درصد', value: 'percent' }, { name: 'مبلغ', value: 'price' }, { name: 'قیمت نهایی', value: 'maxPrice' }],
        size_of_price_decrease_dropdown: [
            { name: 1 }, { name: 10 }, { name: 100 }, { name: 200 }, { name: 300 }, { name: 400 }, { name: 500 },
            { name: 600 }, { name: 700 }, { name: 800 }, { name: 900 }, { name: 1000 }, { name: 2000 }, { name: 5000 },
            { name: 10000 }, { name: 20000 }, { name: 50000 }, { name: 100000 }, { name: 500000 }, { name: 1000000 },
        ],
        roundness_digits_dropdown: [{ name: 0 }, { name: 1 }, { name: 2 }, { name: 3 }, { name: 4 }, { name: 5 }],
        change_price_promotion_dropdown: [{ name: 'فعالیت ربات در تخفیف هوشمند', value: 'true' }, { name: 'بدون تغییر قیمت', value: 'false' }],
        has_increase_price_permission_dropdown: [{ name: 'بدون تغییر قیمت', value: 'false' }, { name: 'افزایش قیمت تا حداکثر سود', value: 'true' }],
        data: {
            // initial
            variation_id: '',
            buy_price: '',
            min_margin_rate: '',
            min_margin_rate_type: 'percent',
            max_margin_rate: '',
            max_margin_rate_type: 'percent',
            // default
            active: true,
            size_of_price_decrease: 100,
            roundness_digits: 2,
            change_price_promotion: true,
            specific_pricing_range: 5,
            has_increase_price_permission: false,
            ancillary_costs: 0,
        },
        tableData: {}
    })
    const tableRef = useRef()

    useEffect(() => {
        if (props.open) {
            if (typeof props.data != 'undefined') {
                resetDefaultData()
                setInitialData()
            }
        } else {
            resetDefaultData()
        }
    }, [props.data])

    const resetDefaultData = () => {
        let tmp = modalData
        tmp.data = {
            variation_id: '',
            buy_price: '',
            min_margin_rate: '',
            min_margin_rate_type: 'percent',
            max_margin_rate: '',
            max_margin_rate_type: 'percent',
            active: true,
            size_of_price_decrease: 100,
            roundness_digits: 2,
            change_price_promotion: true,
            specific_pricing_range: 5,
            has_increase_price_permission: false,
            ancillary_costs: 0,
        }
        tmp.calculateLoading = false
        tmp.error = []
        tmp.showConfirmButton = false
        tmp.tab = 'initialSetting'
        tmp.tableData = {}
        setModalData({ ...tmp })
    }

    const setInitialData = () => {
        let tmp = modalData
        tmp.data = {
            variation_id: props.data._id,
            buy_price: props.data.robot && props.data.robot.buy_price ? props.data.robot.buy_price : '',
            min_margin_rate: props.data.robot && props.data.robot.min_margin_rate ? props.data.robot.min_margin_rate : '',
            min_margin_rate_type: props.data.robot && props.data.robot.min_margin_rate_type ? props.data.robot.min_margin_rate_type : 'percent',
            max_margin_rate: props.data.robot && props.data.robot.max_margin_rate ? props.data.robot.max_margin_rate : '',
            max_margin_rate_type: props.data.robot && props.data.robot.max_margin_rate_type ? props.data.robot.max_margin_rate_type : 'percent',
            active: (props.data.robot && typeof props.data.robot.active != 'undefined') ? props.data.robot.active : true,
            size_of_price_decrease: props.data.robot && props.data.robot.size_of_price_decrease ? props.data.robot.size_of_price_decrease : 100,
            roundness_digits: props.data.robot && typeof props.data.robot.roundness_digits != 'undefined' ? props.data.robot.roundness_digits : 2,
            change_price_promotion: (props.data.robot && typeof props.data.robot.change_price_promotion != 'undefined') ? props.data.robot.change_price_promotion : true,
            specific_pricing_range: props.data.robot && props.data.robot.specific_pricing_range ? props.data.robot.specific_pricing_range : '',
            has_increase_price_permission: (props.data.robot && typeof props.data.robot.has_increase_price_permission != 'undefined') ? props.data.robot.has_increase_price_permission : false,
            ancillary_costs: props.data.robot && props.data.robot.ancillary_costs ? props.data.robot.ancillary_costs : 0,
        }
        setModalData({ ...tmp })
    }

    const editVariant = async () => {
        let tmp = modalData
        if (checkForErrors()) {
            tmp.error = []
            let params = {
                ...modalData.data,
                buy_price: Number(modalData.data.buy_price),
                min_margin_rate: Number(modalData.data.min_margin_rate),
                max_margin_rate: Number(modalData.data.max_margin_rate),
                size_of_price_decrease: Number(modalData.data.size_of_price_decrease),
                roundness_digits: Number(modalData.data.roundness_digits),
                ancillary_costs: Number(modalData.data.ancillary_costs)
            }
            if (props.data.robot && typeof props.data.robot.specific_pricing_range == 'undefined' && modalData.data.specific_pricing_range == '') {
                delete params.specific_pricing_range
            }
            let res = await props.handleEdit(params)
            if (res && res.data && res.data.success) {
                // success toast
                props.parentClose()
            } else {
                // toast the error
                props.toast('ویرایش با اختلال مواجه شد')
            }
        } else {
            props.toast('لطفا قیمت خرید، حداقل حاشیه سود و حداکثر حاشیه سود را وارد کنید. ')
            tmp.error = ['اطلاعات اولیه را وارد کنید']
        }
        tmp.calculateLoading = false
        setModalData({ ...tmp })
    }

    const calculateVariant = async () => {
        let tmp = modalData
        if (checkForErrors()) {
            tmp.calculateLoading = true
            setModalData({ ...tmp })
            tmp.error = []
            let params = {
                ...modalData.data,
                buy_price: Number(modalData.data.buy_price),
                min_margin_rate: Number(modalData.data.min_margin_rate),
                max_margin_rate: Number(modalData.data.max_margin_rate),
                size_of_price_decrease: Number(modalData.data.size_of_price_decrease),
                roundness_digits: Number(modalData.data.roundness_digits),
                ancillary_costs: Number(modalData.data.ancillary_costs)
            }
            let res = await props.handleCalculate(params)
            if (res && res.data && res.data.success) {
                // success toast & show table
                tmp.showConfirmButton = true
                tmp.tableData = res.data.data
            } else {
                // toast the error
                props.toast('محاسبه با اختلال مواجه شد')
            }
        } else {
            props.toast('لطفا قیمت خرید، حداقل حاشیه سود و حداکثر حاشیه سود را وارد کنید. ')
            tmp.error = ['اطلاعات اولیه را وارد کنید']
        }
        tmp.calculateLoading = false
        setModalData({ ...tmp })
        if (modalData.showConfirmButton) {
            tableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    const checkForErrors = () => {
        let canEdit = false
        if (modalData.data.buy_price && modalData.data.min_margin_rate && modalData.data.min_margin_rate_type && modalData.data.max_margin_rate && modalData.data.max_margin_rate_type) {
            canEdit = true
        }
        return canEdit
    }

    const changeTab = tab => {
        let tmp = modalData
        tmp.tab = tab
        setModalData({ ...tmp })
    }

    const handleEditInfo = (tag, e) => {
        let tmp = modalData
        tmp.data[tag] = (typeof e.target != 'undefined' ? toEnglishNumber((e.target.value).replaceAll(',', '')) : e.name)
        setModalData({ ...tmp })
    }

    const handleRadioButton = (tag, value, secondTag) => {
        let tmp = modalData
        if (secondTag.includes('@')) {
            let values = secondTag.split('@')
            tmp.data[values[0]] = values[1]
        } else {
            tmp.data[secondTag] = !modalData.data.active
        }
        setModalData({ ...tmp })
    }

    const deleteAll = type => {
        let tmp = modalData
        tmp.data[type] = ''
        setModalData({ ...tmp })
    }

    return (
        <Modal
            tag="ProSetting"
            title='ویرایش'
            value={props.open}
            closeModal={props.parentClose}
            errors={modalData.error}
            calculateLoading={modalData.calculateLoading}
            sendDataToParent={editVariant}
            calculatePrice={calculateVariant}
            showConfirmButton={modalData.showConfirmButton}
            editModalButtonsPack={true}
            parentClose={props.parentClose}
        >
            {props.open && <div className={style.wrapper}>
                <div className={style.infoHeader}>
                    <div className={style.infoCol}>
                        <p>{props.data.title}</p>
                    </div>
                    <div className={style.infoCol}>
                        <div className={style.colWrapper}>
                            <p className={style.label}>گروه: </p>
                            <p>{props.data.category.title}</p>
                        </div>
                        <div className={style.colWrapper}>
                            <p className={style.label}>برند: </p>
                            <p>{props.data.brand.title}</p>
                        </div>

                        {props.data.variation_attributes.length > 0 && <div className={style.colWrapper}>
                            <p className={style.label}>تنوع: </p>
                            <p>{props.data.variation_attributes[0].value.title}</p>
                        </div>}
                    </div>
                </div>

                <div className={style.tabWrapper}>
                    <div className={modalData.tab == 'initialSetting' ? style.tabSelected : style.tab} onClick={() => changeTab('initialSetting')}>تنظیمات اولیه</div>
                    <div className={modalData.tab == 'defaultSetting' ? style.tabSelected : style.tab} onClick={() => changeTab('defaultSetting')}>تنظیمات پیشرفته</div>
                </div>

                <div className={style.modalBody}>
                    {modalData.tab == 'initialSetting' &&
                        <div className={style.initialWrapper}>
                            <div className={style.rowWrapper}>
                                {/* buy_price */}
                                <div className={style.inputWrapper}>
                                    <Input
                                        type="text"
                                        disabled={false}
                                        label="قیمت خرید"
                                        placeholder="قیمت خرید"
                                        tag="buy_price"
                                        value={numberWithCommas(modalData.data.buy_price)}
                                        error=''
                                        tooltip=''
                                        withToman={true}
                                        withCommas={true}
                                        onchange={(e, tag) => handleEditInfo(e, tag)}
                                        onblur={() => console.log('')}
                                    />
                                </div>
                            </div>
                            <div className={style.rowWrapper}>
                                {/* min_margin_rate */}
                                <p className={style.title}>حداقل حاشیه سود</p>
                                <div className={style.marginWrapper}>
                                    {modalData.margin_type_dropdown.map((typeItem, typeIndex) => <div
                                        key={`mintypeIndex_${typeIndex}`}
                                        className={style.radioWrapper}
                                    >
                                        <RadioButton
                                            value={modalData.data.min_margin_rate_type == typeItem.value ? true : false}
                                            tag={'min_margin_rate_type@' + typeItem.value}
                                            secondTag={'min_margin@' + typeItem.value}
                                            label={typeItem.name}
                                            onclick={handleRadioButton}
                                            keys={'min_margin' + props.data._id + typeItem.value}
                                        />
                                    </div>)}
                                    <div className={style.inputWrapper}>
                                        <Input
                                            type="text"
                                            disabled={false}
                                            label=""
                                            placeholder="حداقل حاشیه سود"
                                            tag="min_margin_rate"
                                            value={numberWithCommas(modalData.data.min_margin_rate)}
                                            error=''
                                            tooltip=''
                                            withToman={modalData.data.min_margin_rate_type !== 'percent' ? true : false}
                                            onchange={handleEditInfo}
                                            onblur={() => console.log('')}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={style.rowWrapper}>
                                {/* max_margin_rate */}
                                <p className={style.title}>حداکثر حاشیه سود</p>
                                <div className={style.marginWrapper}>
                                    {modalData.max_margin_type_dropdown.map((typeItem, typeIndex) => <div
                                        key={`maxtypeIndex_${typeIndex}`}
                                        className={style.radioWrapper}
                                    >
                                        <RadioButton
                                            value={modalData.data.max_margin_rate_type == typeItem.value ? true : false}
                                            tag={'max_margin_rate_type@' + typeItem.value}
                                            secondTag={'max_margin@' + typeItem.value}
                                            label={typeItem.name}
                                            onclick={handleRadioButton}
                                            keys={'max_margin' + props.data._id + typeItem.value}
                                        />
                                    </div>)}
                                    <div className={style.inputWrapper}>
                                        <Input
                                            type="text"
                                            disabled={false}
                                            label=""
                                            placeholder="حداکثر حاشیه سود"
                                            tag="max_margin_rate"
                                            value={numberWithCommas(modalData.data.max_margin_rate)}
                                            error=''
                                            tooltip=''
                                            withToman={modalData.data.max_margin_rate_type !== 'percent' ? true : false}
                                            onchange={handleEditInfo}
                                            onblur={() => console.log('')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {modalData.tab == 'defaultSetting' && <div className={style.defaultWrapper}>
                        <div className={style.initialWrapper}>
                            <div className={style.rowWrapper}>
                                {/* active */}
                                <p className={style.narrowTitle}>وضعیت ربات</p>
                                <SwitchButton
                                    value={modalData.data.active}
                                    tag={'active'}
                                    disabled={false}
                                    onclick={handleRadioButton}
                                />
                            </div>

                            <div className={style.rowWrapper}>
                                {/* size_of_price_decrease */}
                                <p className={style.narrowTitle}>پله تغییر قیمت</p>
                                <div className={style.inputWrapper}>
                                    <SimpleDropDown
                                        tag='size_of_price_decrease'
                                        label=''
                                        value={modalData.data.size_of_price_decrease && toPersianNumber(numberWithCommas(modalData.data.size_of_price_decrease))}
                                        dropdownList={modalData.size_of_price_decrease_dropdown}
                                        hasSearchBox={false}
                                        hasCheckbox={false}
                                        handleSelect={handleEditInfo}
                                        deleteSelectedItems={() => deleteAll('size_of_price_decrease')}
                                        withToman={true}
                                        withCommas={true}
                                        errorMessage=''
                                    />
                                </div>
                            </div>

                            <div className={style.rowWrapper}>
                                {/* roundness_digits */}
                                <p className={style.narrowTitle}>ارقام رند</p>
                                <div className={style.inputWrapper}>
                                    <SimpleDropDown
                                        tag='roundness_digits'
                                        label=''
                                        value={typeof modalData.data.roundness_digits != 'undefined' && toPersianNumber(numberWithCommas(modalData.data.roundness_digits))}
                                        dropdownList={modalData.roundness_digits_dropdown}
                                        hasSearchBox={false}
                                        hasCheckbox={false}
                                        handleSelect={handleEditInfo}
                                        deleteSelectedItems={() => deleteAll('roundness_digits')}
                                        errorMessage=''
                                    />
                                </div>
                            </div>

                            <div className={style.rowWrapper}>
                                {/* change_price_promotion */}
                                <div className={style.titleWithTooltip}>
                                    <p className={style.title}>تخفیف هوشمند</p>
                                    <div className={style.iconWrapper}>
                                        <Tooltip
                                            direction='Left'
                                            text='در صورت تمایل می‌توانید قیمت‌گذاری توسط ربات را برای تنوع‌های موجود در پروموشن نیز فعال کنید.'
                                        />
                                    </div>
                                </div>
                                <div className={style.marginWrapper}>
                                    {modalData.change_price_promotion_dropdown.map((changePriceItem, changePriceIndex) => <div
                                        key={`changePriceIndex_${changePriceIndex}`}
                                        className={style.radioWrapper}
                                    >
                                        <RadioButton
                                            value={String(modalData.data.change_price_promotion) == String(changePriceItem.value) ? true : false}
                                            tag={'change_price_promotion@' + changePriceItem.value}
                                            secondTag={'change_price_promotion@' + changePriceItem.value}
                                            label={changePriceItem.name}
                                            onclick={handleRadioButton}
                                            keys={'change_price_promotion' + props.data._id + changePriceItem.value}
                                        />
                                    </div>)}
                                </div>
                            </div>

                            <div className={style.rowWrapper}>
                                {/* has_increase_price_permission */}
                                <div className={style.titleWithTooltip}>
                                    <p className={style.title}>استراتژی کف قیمت</p>
                                    <div className={style.iconWrapper}>
                                        <Tooltip
                                            direction='Left'
                                            text='با فعال‌سازی این گزینه، در صورتی که قیمت شما به حداقل قیمت رسیده باشد و شما همچنان برنده بای‌باکس نباشید، قیمت شما را تا حداکثر سود افزایش خواهد داد.'
                                        />
                                    </div>
                                </div>
                                <div className={style.marginWrapper}>
                                    {modalData.has_increase_price_permission_dropdown.map((increasePriceItem, increasePriceIndex) => <div
                                        key={`increasePriceIndex_${increasePriceIndex}`}
                                        className={style.radioWrapper}
                                    >
                                        <RadioButton
                                            value={String(modalData.data.has_increase_price_permission) == String(increasePriceItem.value) ? true : false}
                                            tag={'has_increase_price_permission@' + increasePriceItem.value}
                                            secondTag={'has_increase_price_permission@' + increasePriceItem.value}
                                            label={increasePriceItem.name}
                                            onclick={handleRadioButton}
                                            keys={'has_increase_price_permission' + props.data._id + increasePriceItem.value}
                                        />
                                    </div>)}
                                </div>
                            </div>

                            <div className={style.rowWrapper}>
                                {/* ancillary_costs */}
                                <p className={style.narrowTitle}>هزینه‌های جانبی</p>
                                <div className={style.inputWrapper}>
                                    <Input
                                        tag="ancillary_costs"
                                        type="text"
                                        disabled={false}
                                        label=""
                                        placeholder="بازه قیمت‌گذاری دلخواه"
                                        value={numberWithCommas(modalData.data.ancillary_costs)}
                                        error=''
                                        tooltip=''
                                        withToman={true}
                                        onchange={handleEditInfo}
                                        onblur={() => console.log('')}
                                        errorMessage=''
                                    />
                                </div>
                            </div>

                            <div className={style.rowWrapper}>
                                {/* specific_pricing_range */}
                                <p className={style.narrowTitle}>بازه‌ی قیمت‌گذاری دلخواه (دقیقه)</p>
                                <div className={style.inputWrapper}>
                                    <Input
                                        type="text"
                                        disabled={true}
                                        label=""
                                        placeholder="بازه قیمت‌گذاری دلخواه"
                                        tag="specific_pricing_range"
                                        value={modalData.data.specific_pricing_range}
                                        error=''
                                        tooltip=''
                                        withMinute={true}
                                        onchange={handleEditInfo}
                                        onblur={() => console.log('')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    <div className={style.wrongMaximumPriceWrapper}>
                        <span className={style.icon}>n</span>
                        <div className={style.wrongMaximumPrice}>
                            <p>قیمت‌ها به تومان می‌باشند.</p>
                        </div>
                    </div>

                    {modalData.showConfirmButton && <div
                        ref={tableRef}
                        className={style.tableWrapper}
                    >
                        <Tabel data={{
                            ...modalData.tableData,
                            ancillaryCosts: typeof modalData.data.ancillary_costs !== "undefined" && modalData.data.ancillary_costs.toString()
                        }}
                            type='snapp'
                        />
                    </div>}
                </div>
            </div>}
        </Modal>
    )
}
export default ProSetting
